import router from './zh/router'
import login from './zh/login'
import map from './zh/map'
import siteOverview from './zh/siteOverview'
import { updatePassword } from '@/api/userSet'
export default {
  common: {
    confirm: '确认',
    cancel: '取消',
    check: '查看',
    search: '查询',
    export: '导出',
    update: '更新',
    filter: '筛选',
    print: '打印',
    startTime: '开始时间',
    endTime: '结束时间',
    noData: '暂无数据',
    createSuccess: '创建成功',
    addSuccess: '添加成功',
    editSuccess: '修改成功',
    operateSuccess: '操作成功',
    yes: '是',
    no: '否',
    keywords: '关键字',
    phSelect: '请选择',
    phInput: '请输入',
    enterSite: '输入站点名称/站点编码',
    headTitle: '利欧光伏水泵远程监控系统',
    address: '地址',
    goBack: '返回',
    selectIndicators: '选择指标',
    selectSite: '选择站点',
    reset: '重置',
    searchMetrics: '输入关键字搜索指标',
    keywordSearch: '输入关键字搜索'
  },
  time: {
    second: '秒',
    minute: '分',
    hour: '时',
    day: '天',
    month: '月',
    year: '年',
    thisWeek: '本周',
    lastWeek: '上周'
  },
  userSet: {
    userInfor: '个人信息',
    positionSet: '定位设置',
    safeExit: '安全退出'
  },
  controlLog: {
    time: '时间',
    query: '查询',
    export: '导出',
    keyWord: '关键字搜索',
    number: '序号',
    pumpHouseName: '泵房名称',
    deviceName: '设备名称',
    deviceId: '设备ID',
    pageMeasurePoint: '页面测点',
    controlMeasurePoint: '下控测点',
    controlValue: '下控值',
    excuter: '执行人',
    controlTime: '下控时间',
    controlIP: '下控IP',
    controlResult: '操作结果',
    startTime: '开始时间',
    endTime: '结束时间',
    lastWeek: '最近一周',
    lastMonth: '最近一个月',
    lastQuarter: '最近一个季度',
    queryNoData: '查询无数据！',
    title: '提示',
    tip: '是否确定导出该数据?',
    yes: '是',
    no: '否',
    cancelExport: '取消导出!'
  },
  pumpStatus: {
    all: '全部',
    run: '运行',
    run1: '运行中',
    offline: '离线',
    stop: '停机',
    fault: '故障',
    online: '在线',
    startUp: '启动'
  },
  runTime: {
    run: '运行时长',
    offline: '离线时长',
    stop: '停机时长',
    fault: '故障时长'
  },
  energy: {
    kwh: '累计发电量(万kW∙h)',
    kwh1: '累计发电量',
    kwh2: '万kW∙h',
    coal: '标准煤减排(t)',
    so2: 'SO₂减排(t)',
    co2: 'CO₂减排(t)',
    soot: '烟尘减排量(t)',
    nox: 'NOx减排量(t)'
  },
  message: {
    queryNoData: '查询无数据!',
    title: '提示',
    tip: '是否确定导出该数据?',
    printTip: '是否要打印该数据?',
    yes: '是',
    no: '否',
    cancelExport: '取消导出!',
    successExport: '导出成功！',
    noDataExport: '无数据导出！',
    noSelect: '未选择区域/测点!',
    startTime: '开始时间',
    endTime: '结束时间',
    minuTip: '请选择当天时间内！',
    dayTip: '请选择当月时间内！',
    shutDownDevice: '是否停机',
    startUpDevice: '是否运行',
    // reversalDevice: '是否反转',
    // faultResetDevice: '是否故障复位',
    whetherOrNot: '是否',
    pumpSite: '泵站',
    timeVerification: '开始时间不能大于结束时间!',
    exceedDays: '查询时间范围不得大于7天!'
  },
  table: {
    time: '时间',
    user: '用户',
    operate: '操作',
    number: '序号',
    stationName: '站点名称',
    alarmType: '报警类型',
    alarmParameters: '报警参数',
    alarmLevel: '报警等级',
    alarmValue: '报警值',
    setValue: '设定值',
    startTime: '开始时间',
    endTime: '结束时间',
    continueTime: '持续时长',
    alarmState: '报警状态',
    recentAlarmTime: '最近报警时间',
    faultDescription: '故障描述',
    totalAlarms: '累计报警次数',
    all: '全部',
    pointMemo: '测点名称',
    pointValue: '数值',
    pointUnit: '单位',
    timestamp: '更新时间'
  },
  alarm: {
    alarmType: '报警类型',
    alarmLevel: '报警等级',
    alarmState: '报警状态'
  },
  page: {
    total: '共',
    items: '条数据'
  },
  router,
  login,
  map,
  siteOverview
}
